import script from "./HistorialModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./HistorialModalComponent.vue?vue&type=style&index=0&id=7fd6167a&lang=css"

const __exports__ = script;

export default __exports__